import { Category, Product } from "@dashboard/modules/products/types/products.types";
import {
  OfferState,
  OfferWizardStep,
} from "../constants/offers.constants";
import { Offer, OfferDraft } from "../entities/offer.entity";
import { createEmptyDraft } from "../utils/validate-offer";

export interface OffersUiState {
  searchQuery: string;
  activeFilters: OfferState[];
  wizardStep: OfferWizardStep;
  showDeleteModal: boolean;
  showExpiredModal: boolean;
  isSaving: boolean;
  isLoading: boolean;
}

export interface OffersDataState {
  offers: Offer[];
  catalogueProducts: Product[];
  categories: Category[];
  draftOffer: OfferDraft;
  selectedOffer?: Offer;
}

export interface OffersState {
  ui: OffersUiState;
  data: OffersDataState;
}

export const initialState: OffersState = {
  ui: {
    searchQuery: "",
    activeFilters: [],
    wizardStep: OfferWizardStep.Selector,
    showDeleteModal: false,
    showExpiredModal: false,
    isSaving: false,
    isLoading: false,
  },
  data: {
    offers: [],
    catalogueProducts: [],
    categories: [],
    draftOffer: createEmptyDraft(),
    selectedOffer: undefined,
  },
};
